import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useLoader } from "../../_helper/LoaderContext";
import {
    createEquipment,
    updateEquipment,
    EQUIPMENT_CATEGORIES,
} from "./service/equipment-service";

const initialForm = {
    name: "",
    code: "",
    description: "",
    category: "",
};

const normalizeCategory = (value) => {
    if (Array.isArray(value)) return value[0] || "";
    if (typeof value === "string") return value;
    return "";
};

export default function AddEquipment({ handleClose, data, getList }) {
    const { t } = useTranslation();
    const { setLoading } = useLoader();
    const [form, setForm] = useState(initialForm);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (data) {
            setForm({
                name: data.name || "",
                // code: data.code || "",
                description: data.description || "",
                category: normalizeCategory(data.category),
            });
        } else {
            setForm(initialForm);
        }
        setErrors({});
    }, [data]);

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
        setErrors((prev) => ({ ...prev, [field]: "" }));
    };

    const validate = () => {
        const next = {};
        if (!form.name.trim()) next.name = t("Please enter equipment name");
        // if (!form.code.trim()) next.code = t("Please enter equipment code");
        if (!form.category) next.category = t("Please select category");
        setErrors(next);
        return Object.keys(next).length === 0;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        const formData = new FormData();
        formData.append("name", form.name.trim());
        // formData.append("code", form.code.trim());
        formData.append("description", form.description.trim());
        formData.append("category", form.category);

        setLoading(true);
        try {
            const res = data
                ? await updateEquipment(data._id, formData)
                : await createEquipment(formData);

            if (res.data.success === true) {
                toast.success(res.data.message);
                getList();
                handleClose();
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal.Body>
                <Form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}
                >
                    <Form.Group className="mb-3" controlId="equipmentName">
                        <Form.Label>
                            {t("Equipment Name")}
                            <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder={t("Enter equipment name")}
                            value={form.name}
                            onChange={(e) => handleChange("name", e.target.value)}
                            isInvalid={!!errors.name}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.name}
                        </Form.Control.Feedback>
                    </Form.Group>

                    {/* <Form.Group className="mb-3" controlId="equipmentCode">
                        <Form.Label>
                            {t("Code")}
                            <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder={t("Enter code (e.g. EQP-0001)")}
                            value={form.code}
                            onChange={(e) => handleChange("code", e.target.value)}
                            isInvalid={!!errors.code}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.code}
                        </Form.Control.Feedback>
                    </Form.Group> */}

                    <Form.Group className="mb-3" controlId="equipmentCategory">
                        <Form.Label>
                            {t("Category")}
                            <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                            value={form.category}
                            onChange={(e) => handleChange("category", e.target.value)}
                            isInvalid={!!errors.category}
                        >
                            <option value="">{t("Select category")}</option>
                            {EQUIPMENT_CATEGORIES.map((cat) => (
                                <option key={cat} value={cat}>
                                    {cat}
                                </option>
                            ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            {errors.category}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-0" controlId="equipmentDescription">
                        <Form.Label>{t("Description")}</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder={t("Enter description")}
                            value={form.description}
                            onChange={(e) => handleChange("description", e.target.value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleSubmit}>
                    {data ? "Update" : "Create"}
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </>
    );
}
